'use client'

import * as React from 'react'
import { CaretSortIcon, CheckIcon, ChevronDownIcon, ChevronUpIcon } from '@radix-ui/react-icons'
import * as SelectPrimitive from '@radix-ui/react-select'
import * as ScrollArea from '@radix-ui/react-scroll-area'
import arrow from 'public/arrow=20.svg'
import Image from 'next/image'
import './styles.css'
import { cn } from '../../utils/cn'
const Select = SelectPrimitive.Root
// const Select = React.forwardRef<React.ElementRef<typeof SelectPrimitive.Root>, React.ComponentPropsWithoutRef<typeof SelectPrimitive.Root>>(
//   ({ children, ...props }, ref) => {
//     console.log('Select props:', props)
//     return <SelectPrimitive.Root {...props}>{children}</SelectPrimitive.Root>
//   },
// )
// Select.displayName = SelectPrimitive.Root.displayName
const SelectGroup = SelectPrimitive.Group

const SelectValue = SelectPrimitive.Value

// const SelectTrigger = React.forwardRef<React.ElementRef<typeof SelectPrimitive.Trigger>, React.ComponentPropsWithoutRef<typeof SelectPrimitive.Trigger>>(
//   ({ className, children, ...props }, ref) => (
//     <SelectPrimitive.Trigger
//       ref={ref}
//       className={cn(
//         'text-input flex w-full items-center justify-between whitespace-nowrap rounded-lg border border-input bg-transparent px-4 py-3 font-light shadow-sm ring-offset-background transition-colors placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50 ',
//         className,
//       )}
//       // className={cn(
//       // 	'flex  w-full items-center justify-between whitespace-nowrap rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1',
//       // 	className
//       // )}
//       {...props}
//       // aria-expanded={'true'}
//       // data-state='open'
//     >
//       {children}
//       <div className="flex w-full justify-between">
//         <SelectValue />
//         <SelectPrimitive.Icon asChild>
//           <Image
//             src={arrow}
//             alt="Chevron Down"
//             // width={24}
//             // height={24}
//             className={cn(`cursor-pointer`)}
//             // className={`cursor-pointer ${isPopoverOpen ? 'animate-rotate180' : 'animate-rotate0'}`}
//           />
//           {/* <CaretSortIcon className='w-4 h-4 opacity-50' /> */}
//         </SelectPrimitive.Icon>
//       </div>
//     </SelectPrimitive.Trigger>
//   ),
// )
type SelectTriggerPropsCustom = React.ComponentPropsWithoutRef<typeof SelectPrimitive.Trigger> & {
  closeButton?: React.ReactNode
}
const SelectTrigger = React.forwardRef<
  React.ElementRef<typeof SelectPrimitive.Trigger>,
  SelectTriggerPropsCustom
  // const SelectTrigger = React.forwardRef<
  //   React.ElementRef<typeof SelectPrimitive.Trigger>,
  //   React.ComponentPropsWithoutRef<typeof SelectPrimitive.Trigger>
>(({ className, children, ...props }, ref) => (
  <SelectPrimitive.Trigger
    ref={ref}
    className={cn(
      'text-input flex w-full items-center justify-between whitespace-nowrap rounded-lg border border-input bg-transparent px-4 py-3 font-light shadow-sm ring-offset-background transition-colors placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50 ',
      'relative z-50 data-[state=open]:ring-1 data-[state=open]:ring-ring',
      'aria-[invalid=true]:border-destructive-foreground',
      // 'relative z-50 data-[state=open]:ring-1 data-[state=open]:ring-ring',
      className,
    )}
    {...props}
  >
    {children}
    <div className="flex w-full justify-between">
      <SelectValue />
      {props?.closeButton && props.closeButton}
      <SelectPrimitive.Icon asChild>
        <Image
          src={arrow}
          alt="Chevron Down"
          // width={24}
          // height={24}
          className={cn(`cursor-pointer`)}
          // className={`cursor-pointer ${isPopoverOpen ? 'animate-rotate180' : 'animate-rotate0'}`}
        />
        {/* <CaretSortIcon className='w-4 h-4 opacity-50' /> */}
      </SelectPrimitive.Icon>
    </div>
  </SelectPrimitive.Trigger>
))

// const SelectTrigger2 = React.forwardRef<React.ElementRef<typeof SelectPrimitive.Trigger>, React.ComponentPropsWithoutRef<typeof SelectPrimitive.Trigger>>(
//   ({ className, children, ...props }, ref) => (
//     <SelectPrimitive.Trigger
//       ref={ref}
//       className={cn(
//         'text-input flex w-full items-center justify-between whitespace-nowrap rounded-lg border border-input bg-transparent px-4 py-3 font-light shadow-sm ring-offset-background transition-colors placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50 ',
//         className,
//       )}
//       {...props}
//     >
//       <div className="flex w-full justify-between">
// 				<SelectValue />
//         <SelectPrimitive.Icon asChild>
//           <Image
//             src={arrow}
//             alt="Chevron Down"
//             className={cn(`cursor-pointer`)}
//           />
//         </SelectPrimitive.Icon>
//       </div>
//     </SelectPrimitive.Trigger>
//   ),
// )
SelectTrigger.displayName = SelectPrimitive.Trigger.displayName

// const SelectScrollUpButton = React.forwardRef<React.ElementRef<typeof SelectPrimitive.ScrollUpButton>, React.ComponentPropsWithoutRef<typeof SelectPrimitive.ScrollUpButton>>(
// 	({ className, ...props }, ref) => (
// 		<SelectPrimitive.ScrollUpButton
// 			ref={ref}
// 			className={cn('flex cursor-default items-center justify-center py-1', className)}
// 			{...props}
// 		>
// 			<ChevronUpIcon />
// 		</SelectPrimitive.ScrollUpButton>
// 	)
// )
// SelectScrollUpButton.displayName = SelectPrimitive.ScrollUpButton.displayName

// const SelectScrollDownButton = React.forwardRef<React.ElementRef<typeof SelectPrimitive.ScrollDownButton>, React.ComponentPropsWithoutRef<typeof SelectPrimitive.ScrollDownButton>>(
// 	({ className, ...props }, ref) => (
// 		<SelectPrimitive.ScrollDownButton
// 			ref={ref}
// 			className={cn('flex cursor-default items-center justify-center py-1', className)}
// 			{...props}
// 		>
// 			<ChevronDownIcon />
// 		</SelectPrimitive.ScrollDownButton>
// 	)
// )
// SelectScrollDownButton.displayName = SelectPrimitive.ScrollDownButton.displayName

const SelectContent = React.forwardRef<
  React.ElementRef<typeof SelectPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof SelectPrimitive.Content>
>(({ className, children, position = 'popper', ...props }, ref) => (
  <SelectPrimitive.Portal>
    <SelectPrimitive.Content
      ref={ref}
      className={cn(
        'relative z-50  max-h-[180px] min-w-[8rem] overflow-auto  rounded-lg border bg-background text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        // 'relative z-50  max-h-[180px] min-w-[8rem] overflow-auto  rounded-lg border bg-background text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        position === 'popper' &&
          'custom-scrollbar data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1',
        className,
      )}
      position={position}
      {...props}
    >
      <div
      // className={cn(
      // 	'pr-8 box-border',
      // 	position === 'popper' && 'h-[var(--radix-select-trigger-height)] w-full min-w-[calc(var(--radix-select-trigger-width)_-_var(--scrollbar-size)_-20px)]'
      // )}
      >
        <ScrollArea.Root
          className="ScrollAreaRoot "
          // className={cn(
          // 	'ScrollAreaRoot',
          // 	'p-8 box-content'
          // )}
          type="auto"
        >
          {/* <SelectScrollUpButton /> */}
          {/* после cn можно указать класс для контейнера в котором лежат опции */}

          <SelectPrimitive.Viewport
            asChild
            // className={cn('overflow-visible', position === 'popper' && 'h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]')}
          >
            {/* <SelectPrimitive.Viewport className={cn('p-1', position === 'popper' && 'h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]')}> */}
            <ScrollArea.Viewport
              className={cn(
                'ScrollAreaViewport',
                position === 'popper' &&
                  'min-h-[var(--radix-select-trigger-height)] w-full min-w-[calc(var(--radix-select-trigger-width)_-_var(--scrollbar-size))]',
              )}
              style={{
                // VAR: это убирает ошибку из консоли браузера
                overflowY: 'auto',
              }}
            >
              {children}
            </ScrollArea.Viewport>
            {/* <ScrollArea.Viewport className='ScrollAreaViewport'>{children}</ScrollArea.Viewport> */}
          </SelectPrimitive.Viewport>
          <ScrollArea.Scrollbar
            className="ScrollAreaScrollbar"
            orientation="vertical"
          >
            <ScrollArea.Thumb className="ScrollAreaThumb" />
          </ScrollArea.Scrollbar>
        </ScrollArea.Root>
      </div>
      {/* <SelectScrollDownButton /> */}
    </SelectPrimitive.Content>
  </SelectPrimitive.Portal>
))
SelectContent.displayName = SelectPrimitive.Content.displayName

const SelectLabel = React.forwardRef<
  React.ElementRef<typeof SelectPrimitive.Label>,
  React.ComponentPropsWithoutRef<typeof SelectPrimitive.Label>
>(({ className, ...props }, ref) => (
  <SelectPrimitive.Label
    ref={ref}
    className={cn('px-2 py-1.5 text-sm font-semibold', className)}
    {...props}
  />
))
SelectLabel.displayName = SelectPrimitive.Label.displayName

const SelectItem = React.forwardRef<
  React.ElementRef<typeof SelectPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof SelectPrimitive.Item>
>(({ className, children, ...props }, ref) => (
  <SelectPrimitive.Item
    ref={ref}
    className={cn(
      'text-input relative flex w-full cursor-pointer select-none items-center rounded-sm px-4 py-2 font-light outline-none  data-[disabled]:pointer-events-none data-[state=checked]:font-medium data-[disabled]:opacity-50',
      'focus:font-medium',
      // 'focus:text-cyan-800',
      className,
    )}
    // className={cn(
    // 	'relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-2 pr-8 text-input outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
    // 	className
    // )}
    {...props}
  >
    <span className="absolute right-2 flex h-3.5 w-3.5 items-center justify-center">
      <SelectPrimitive.ItemIndicator>{/* <CheckIcon className="h-4 w-4" /> */}</SelectPrimitive.ItemIndicator>
    </span>
    <SelectPrimitive.ItemText>{children}</SelectPrimitive.ItemText>
  </SelectPrimitive.Item>
))
SelectItem.displayName = SelectPrimitive.Item.displayName

const SelectSeparator = React.forwardRef<
  React.ElementRef<typeof SelectPrimitive.Separator>,
  React.ComponentPropsWithoutRef<typeof SelectPrimitive.Separator>
>(({ className, ...props }, ref) => (
  <SelectPrimitive.Separator
    ref={ref}
    className={cn('-mx-1 my-1 h-px bg-muted', className)}
    {...props}
  />
))
SelectSeparator.displayName = SelectPrimitive.Separator.displayName

export { Select, SelectGroup, SelectValue, SelectTrigger, SelectContent, SelectLabel, SelectItem, SelectSeparator }
// 'use client'

// import * as React from 'react'
// import { CaretSortIcon, CheckIcon, ChevronDownIcon, ChevronUpIcon } from '@radix-ui/react-icons'
// import * as SelectPrimitive from '@radix-ui/react-select'

// import { cn } from '../utils/cn'
// import arrow from 'public/arrow=20.svg'
// import Image from 'next/image'
// const Select = SelectPrimitive.Root

// const SelectGroup = SelectPrimitive.Group

// const SelectValue = SelectPrimitive.Value

// const SelectTrigger = React.forwardRef<React.ElementRef<typeof SelectPrimitive.Trigger>, React.ComponentPropsWithoutRef<typeof SelectPrimitive.Trigger>>(
// 	({ className, children, ...props }, ref) => (
// 		<SelectPrimitive.Trigger
// 			ref={ref}
// 			className={cn(
// 				'flex w-full px-4 py-3 items-center justify-between whitespace-nowrap font-light transition-colors bg-transparent border rounded-lg border-input text-input shadow-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1',
// 				className
// 			)}
// 			// className={cn(
// 			// 	'flex  w-full items-center justify-between whitespace-nowrap rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1',
// 			// 	className
// 			// )}
// 			{...props}
// 			// aria-expanded={'true'}
// 			// data-state='open'
// 		>
// 			{children}
// 			<div className='flex w-full justify-between'>
// 				<SelectValue />
// 				<SelectPrimitive.Icon asChild>
// 					<Image
// 						src={arrow}
// 						alt='Chevron Down'
// 						// width={24}
// 						// height={24}
// 						className={cn(`cursor-pointer`)}
// 						// className={`cursor-pointer ${isPopoverOpen ? 'animate-rotate180' : 'animate-rotate0'}`}
// 					/>
// 					{/* <CaretSortIcon className='w-4 h-4 opacity-50' /> */}
// 				</SelectPrimitive.Icon>
// 			</div>
// 		</SelectPrimitive.Trigger>
// 	)
// )
// SelectTrigger.displayName = SelectPrimitive.Trigger.displayName

// const SelectScrollUpButton = React.forwardRef<React.ElementRef<typeof SelectPrimitive.ScrollUpButton>, React.ComponentPropsWithoutRef<typeof SelectPrimitive.ScrollUpButton>>(
// 	({ className, ...props }, ref) => (
// 		<SelectPrimitive.ScrollUpButton
// 			ref={ref}
// 			className={cn('flex cursor-default items-center justify-center py-1', className)}
// 			{...props}
// 		>
// 			<ChevronUpIcon />
// 		</SelectPrimitive.ScrollUpButton>
// 	)
// )
// SelectScrollUpButton.displayName = SelectPrimitive.ScrollUpButton.displayName

// const SelectScrollDownButton = React.forwardRef<React.ElementRef<typeof SelectPrimitive.ScrollDownButton>, React.ComponentPropsWithoutRef<typeof SelectPrimitive.ScrollDownButton>>(
// 	({ className, ...props }, ref) => (
// 		<SelectPrimitive.ScrollDownButton
// 			ref={ref}
// 			className={cn('flex cursor-default items-center justify-center py-1', className)}
// 			{...props}
// 		>
// 			<ChevronDownIcon />
// 		</SelectPrimitive.ScrollDownButton>
// 	)
// )
// SelectScrollDownButton.displayName = SelectPrimitive.ScrollDownButton.displayName

// const SelectContent = React.forwardRef<React.ElementRef<typeof SelectPrimitive.Content>, React.ComponentPropsWithoutRef<typeof SelectPrimitive.Content>>(
// 	({ className, children, position = 'popper', ...props }, ref) => (
// 		<SelectPrimitive.Portal>
// 			<SelectPrimitive.Content
// 				ref={ref}
// 				className={cn(
// 					'relative z-50 max-h-96 min-w-[8rem] overflow-visible rounded-lg border bg-background text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
// 					position === 'popper' && 'data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1',
// 					className
// 				)}
// 				position={position}
// 				{...props}
// 			>
// 				{/* <SelectScrollUpButton /> */}
// 				{/* после cn можно указать класс для контейнера в котором лежат опции */}
// 				<SelectPrimitive.Viewport
// 					className={cn('overflow-visible', position === 'popper' && 'h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]')}
// 				>
// 					{/* <SelectPrimitive.Viewport className={cn('p-1', position === 'popper' && 'h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]')}> */}
// 					{children}
// 				</SelectPrimitive.Viewport>
// 				{/* <SelectScrollDownButton /> */}
// 			</SelectPrimitive.Content>
// 		</SelectPrimitive.Portal>
// 	)
// )
// SelectContent.displayName = SelectPrimitive.Content.displayName

// const SelectLabel = React.forwardRef<React.ElementRef<typeof SelectPrimitive.Label>, React.ComponentPropsWithoutRef<typeof SelectPrimitive.Label>>(
// 	({ className, ...props }, ref) => (
// 		<SelectPrimitive.Label
// 			ref={ref}
// 			className={cn('px-2 py-1.5 text-sm font-semibold', className)}
// 			{...props}
// 		/>
// 	)
// )
// SelectLabel.displayName = SelectPrimitive.Label.displayName

// const SelectItem = React.forwardRef<React.ElementRef<typeof SelectPrimitive.Item>, React.ComponentPropsWithoutRef<typeof SelectPrimitive.Item>>(
// 	({ className, children, ...props }, ref) => (
// 		<SelectPrimitive.Item
// 			ref={ref}
// 			className={cn(
// 				'relative flex w-full cursor-pointer select-none items-center rounded-sm px-4 py-2 text-input font-light outline-none focus:text-cyan-800 data-[state=checked]:font-medium data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
// 				className
// 			)}
// 			// className={cn(
// 			// 	'relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-2 pr-8 text-input outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
// 			// 	className
// 			// )}
// 			{...props}
// 		>
// 			<span className='absolute right-2 flex h-3.5 w-3.5 items-center justify-center'>
// 				<SelectPrimitive.ItemIndicator>
// 					<CheckIcon className='w-4 h-4' />
// 				</SelectPrimitive.ItemIndicator>
// 			</span>
// 			<SelectPrimitive.ItemText>{children}</SelectPrimitive.ItemText>
// 		</SelectPrimitive.Item>
// 	)
// )
// SelectItem.displayName = SelectPrimitive.Item.displayName

// const SelectSeparator = React.forwardRef<React.ElementRef<typeof SelectPrimitive.Separator>, React.ComponentPropsWithoutRef<typeof SelectPrimitive.Separator>>(
// 	({ className, ...props }, ref) => (
// 		<SelectPrimitive.Separator
// 			ref={ref}
// 			className={cn('-mx-1 my-1 h-px bg-muted', className)}
// 			{...props}
// 		/>
// 	)
// )
// SelectSeparator.displayName = SelectPrimitive.Separator.displayName

// export { Select, SelectGroup, SelectValue, SelectTrigger, SelectContent, SelectLabel, SelectItem, SelectSeparator, SelectScrollUpButton, SelectScrollDownButton }
